import { Map, List } from "immutable";
import * as Actions from "UserAuthorized/actionTypes";

const InitialState = {
  errors: List()
};

const errorReducer = (state = Map(InitialState), action) => {
  const errors = state.get("errors");
  const newErrors = errors.push(
    `Error occurs on action: '${action.type}', message: '${action.payload}'`
  );

  switch (action.type) {
    case Actions.ENUM_GET_ACTIONS_ERROR:
    case Actions.ACTION_SAVE_ACTION_ERROR:
    case Actions.SECURITY_GET_USER_ERROR:
      return state.set("errors", newErrors);
    default:
      return state;
  }
};

export default errorReducer;
